module.exports = __webpack_public_path__ + "img/634-3a8592.png";